import Vue from "vue";
import axios from "axios";
import { io } from 'socket.io-client';

let instance;

export const getInstance = () => instance;

export const useEventGateway = (opts) => {
    if (instance) return instance;
  
    let defaultOptions = {
        events: [],
        count: 0,
        socket:null,
        connectionState: false,
        un: ""
    }

    instance = new Vue({
      data: () => ({ ...defaultOptions, ...opts }),
      methods: {
        registerListeners(){
            this.socket.on('disconnect', (reason) => {
                console.warn(`[EventGateway] Disconnected: ${reason}`);
                this.connectionState = false;
                // Socket.IO auto-reconnects unless the server explicitly disconnected us
                if (reason === 'io server disconnect') {
                  console.log('[EventGateway] Server forced disconnect — will not auto-reconnect');
                }
            });

            this.socket.on("*", (event,data) => {
                this.$emit(event,data);
            });
        },
        getLogs() {
            axios
            .get(`message/eventsLog`)
            .then((resp) => {
                if (resp.data.Status === "OK") {
                    this.events = resp.data.Data;
                }
            })
            .catch((err) => {
            if (err.response && err.response.status === 401) {
                this.$emit("sessionExpired", err);
            } else {
                console.log(err);
                this.response = err.response
                ? err.response.data
                : { message: "Unexpected Error" };
            }
            this.isLoading = false;
            });
        },
        getRecentEvents(){
            return this.events.splice(0,5);
        },
        connect(un, token){
            if (this.socket) {
                return;
            }

            const loginState = Vue.prototype.$loginState;
            const atlasAvailable = !!loginState?.user?.settings?.some(
                s => s.setting === 'atlas_available' && s.value === 'true'
            );
            if (!atlasAvailable || !loginState.checkForPermission('atlas_flyout_permission_groups')) {
                console.log('[EventGateway] Atlas not enabled for this user — skipping gateway connection');
                return;
            }

            const url = process.env.VUE_APP_EVENT_GATEWAY_URL;
            console.log(`[EventGateway] connect() called`, {
                url,
                hasToken: !!token,
                tokenPreview: token ? token.substring(0, 20) + '...' : null,
                un,
            });

            if (!token) {
              console.warn('[EventGateway] No auth token passed to connect() — server will reject');
            }

            this.socket = io(url, {
                transports: ['websocket'],
                upgrade: false,
                auth: token ? { token } : undefined,
                query: {
                    "un": un
                  },
                reconnectionAttempts: 15,
                reconnectionDelayMax: 30000,
            });

            this.socket.on('connect', () => {
                console.log('[EventGateway] Connected! socket.id =', this.socket.id);
                this.getLogs();
                this.un = un;
                this.connectionState = true;
                this.$emit("connected","Connected to Events Gateway");
            });

            this.socket.on('connect_error', (err) => {
                console.error('[EventGateway] connect_error:', err.message, err);
            });

            this.socket.io.on('reconnect_attempt', (attempt) => {
                console.log('[EventGateway] Reconnect attempt #' + attempt);
            });

            this.socket.io.on('error', (err) => {
                console.error('[EventGateway] Transport error:', err);
            });

            this.socket.io.on('reconnect_failed', () => {
                console.error('[EventGateway] Reconnect failed — giving up');
                this.connectionState = false;
                this.socket = null;
            });

            this.registerListeners();
            var onevent = this.socket.onevent;

            this.socket.onevent = function (packet) {
                var args = packet.data || [];
                onevent.call (this, packet);
                packet.data = ["*"].concat(args);
                onevent.call(this, packet);
            };
        },
        disconnect (){
            if (this.socket) {
                this.socket.disconnect();
                this.socket = null;
                this.connectionState = false;
            }
        },
        send(fn, data){
            console.log(fn,data);
            this.socket.emit(fn,data);
        },
        message(msg){
            this.events.push(msg);
        },
        transformMessageToEvent(event,data){
            console.log(event);
            console.log(data);
        }
      },
    });
  
    return instance;
};

const EventGatewayPlugin = {
    install(Vue, options) {
        Vue.prototype.$eventGateway = useEventGateway(options);
    }
}

export default EventGatewayPlugin;